var IbeTracker = /** @class */ (function () {
    function IbeTracker() {
        var _this = this;
        this._metricService = null;
        this._eventQueue = [];
        this.resolveTrackerManager(function (trackerManager) {
            _this._metricService = trackerManager.IbeMetric
                && trackerManager.IbeMetric();
            _this._eventQueue.forEach(function (event) {
                _this.event(event.type, event.data);
            });
        });
    }
    IbeTracker.prototype.resolveTrackerManager = function (callback) {
        window.TL.modules.run(function (_require) {
            callback(_require('int/tracker'));
        });
    };
    IbeTracker.prototype.event = function (type, data) {
        try {
            if (this._metricService) {
                this._metricService.event(type, data);
            }
            else {
                this._eventQueue.push({
                    type: type,
                    data: data
                });
            }
        }
        catch (ex) {
        }
    };
    return IbeTracker;
}());
export { IbeTracker };
